module.exports = __webpack_public_path__ + "img/empresas_bancos_unidos.2e0f1fc9.svg";